import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, asyncScheduler, of, scheduled } from 'rxjs';
import { map } from 'rxjs/operators';
import { Config, ConfigBase } from '../../model/config/config.model';
import { EntityBase } from '../../model/entity/entity.model';
import { CacheService } from '../cache/cache.service';
import { Location } from '@angular/common';

@Injectable({
	providedIn: 'root'
})
export class ConfigService {

	protected resourceUrl: string = "/rest/security/config"

	e2URL: string = "";

	config: Config = new ConfigBase()

	public initializationAttempted = false

	constructor(private http: HttpClient, protected cacheService: CacheService, private location: Location) { }

	// Initial loggin method, executed on app.module.ts on initial providers //
	public initLoggin(): Promise<void> {
		let currentPath = this.location.path()
        if (currentPath.indexOf("/fullscreen/form-print/") >= 0 || currentPath.indexOf("/print") == 0) {
            return Promise.resolve()
        }
		
		return this.init().toPromise().then(
			(r) => {
				this.initializationAttempted = true
			}
		).catch(
			(r) => {
				console.error("Error logging: ", r)
				return new Promise(() => {})  // Keeps the promise open to stop bootstrap
			}
		)
	}

	public init(): Observable<Config> {
		if (this.config.isEmpty() == false) {
			return scheduled(of(this.config), asyncScheduler)
		}

        const currentUrl = window.location.href

        const initUrl = !currentUrl.includes('/redirect?')
            ? `${this.resourceUrl}/init`
            : `${this.resourceUrl}/init?redirect_uri=${encodeURIComponent(currentUrl)}`

        return this.http.get<Config>(initUrl).pipe(map(result => {
			this.config = ConfigBase.fromConfig(result)
			return this.config
		}))
	}

    public changeEns(userEntityId: number): Observable<Config> {
        return this.http.get<Config>(`${this.resourceUrl}/changeEns/${userEntityId}`).pipe(map(result => {
            return result;
        }))
    }

    public changeEnsByIne10(ine10: string): Observable<Config> {
        return this.http.get<Config>(`${this.resourceUrl}/changeEnsByIne10/${ine10}`).pipe(map(result => {
            return result;
		}))
	}

	public impersonate(identifier: string): Observable<{ ok: boolean, entity: Config, messageCode: string }> {
		return this.http.post<{ ok: boolean, entity: Config, messageCode: string }>(`${this.resourceUrl}/impersonate`, identifier).pipe(map(result => {
			if (result.ok == true) {
				this.cacheService.clear()

				if (result.entity.connectedEntityDetail != null) {
					this.config = ConfigBase.fromConfig(result.entity)
					result.entity = this.config
				}
			}
			return result
		}))
	}

	getConnectedEntity(): EntityBase {
		return this.config.connectedEntityDetail.entity
	}

	public findURLE2(): Observable<string> {
		if (this.e2URL == "") {
			return this.http.get(`${this.resourceUrl}/loadE2URL`, { responseType: 'text' }).pipe(map(r => {
				this.e2URL = r
				return this.e2URL
			}))
		}
		return of(this.e2URL);
	}

    public isInitEndPoint(requestUrl: string): boolean {
        return requestUrl.endsWith('/init') || requestUrl.includes('/init?redirect_uri=')
    }

	public hasCertificateUploaded(): Observable<{ ok: boolean, messageCode: string }> {
		return this.http.get<{ ok: boolean, messageCode: string }>(`${this.resourceUrl}/hasCertificateUploaded`).pipe(map(result => {
			return result
		}))
	}
	
}
